import React from 'react';
import './footer.scss';
import {useTranslation} from 'react-i18next';
import decodeToken from "../../../utils/decode-token";

function Footer() {

  const {t} = useTranslation();
  const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;

  return (
    <footer>
      <section>
        <div className="inner">
          {role === 'hac' && (
            loggedUser?.preferred_language === 'en' ? (
              <>
                <ul>
                  { t(`legal-print-text-${loggedUser?.preferred_language || loggedUser?.preferredLanguage}-${loggedUser.area_code}`) !== "" && (
                    <li><a
                      href="/hac/legal/print">{t(`legal-print-title-${loggedUser?.preferred_language || loggedUser?.preferredLanguage || loggedUser.preferredLanguage}-${loggedUser.area_code}`)}</a>
                    </li>
                  )}

                  <li><a
                    href="/hac/legal/privacy">{t(`legal-privacy-title-${loggedUser?.preferred_language || loggedUser?.preferredLanguage}-${loggedUser.area_code}`)}</a>
                  </li>
                  <li><a
                    href="/hac/legal/terms">{t(`legal-terms-title-${loggedUser?.preferred_language || loggedUser?.preferredLanguage}-${loggedUser.area_code}`)}</a>
                  </li>
                </ul>
                <p>{t(`legal-footer-${loggedUser?.preferred_language || loggedUser?.preferredLanguage}-${loggedUser.area_code}`)}</p>
              </>
            ) : (
              <>
                <ul>
                  { t('legal-print-title') !== '' && (
                    <li><a
                      href="/hac/legal/print">{t('legal-print-title')}</a>
                    </li>
                  )}
                  <li><a
                    href="/hac/legal/privacy">{t('legal-privacy-title')}</a>
                  </li>
                  <li><a
                    href="/hac/legal/terms">{t('legal-terms-title')}</a>
                  </li>
                </ul>
                <p>{t('legal-footer')}</p>
              </>
            )
          )}


        </div>
      </section>
    </footer>
);
}

export default Footer;
